/* tslint:disable */
import { Directive, forwardRef } from '@angular/core';
import { FormControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

/*
supplier da kullanim sekli
 <input class="form-control" id="modal-contactEmail" type="text" [(ngModel)]="supplier.contactEmail" formControlName="contactEmail" name="contactEmail" emailMatcher required>
 */
function emailMatcher(): ValidatorFn {
	return (c: FormControl) => {
		const EMAIL_REGEXP =
			/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;

		return EMAIL_REGEXP.test(c.value)
			? null
			: {
					'sistek-email-pattern': {
						valid: false,
					},
				};
	};
}

@Directive({
	selector: '[sistek-email-pattern]',
	providers: [{ provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SistekEmailPattern) }],
	standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class SistekEmailPattern {
	validator: ValidatorFn;

	constructor() {
		this.validator = emailMatcher();
	}

	validate(c: FormControl) {
		return this.validator(c);
	}
}
